import get from "lodash/get";
import {useSelector} from "react-redux";
import { selectUser } from "redux/slices/userSlice";

export function usePermission(permission) {
  const user = useSelector(selectUser);

  return Boolean(get(user, `permissions.${permission}`));
}
